import type { SVGProps } from 'react';

type GlyphProps = SVGProps<SVGSVGElement> & { className?: string };

const baseProps: SVGProps<SVGSVGElement> = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

export function PriestessGlyph(props: GlyphProps) {
  // Classic crescent moon (Lucide-style geometry) — instantly readable.
  return (
    <svg {...baseProps} {...props}>
      <path d="M 21 12.79 A 9 9 0 1 1 11.21 3 A 7 7 0 0 0 21 12.79 Z" />
    </svg>
  );
}

export function SensualistGlyph(props: GlyphProps) {
  return (
    <svg {...baseProps} {...props}>
      <path d="M12 19c-3.4-2-6-4.6-6-7.5A3.5 3.5 0 0 1 12 9a3.5 3.5 0 0 1 6 2.5c0 2.9-2.6 5.5-6 7.5Z" />
      <path d="M12 9c0 3.5-2.6 5.5-4 6.5M12 9c0 3.5 2.6 5.5 4 6.5" opacity="0.65" />
      <circle cx="12" cy="12" r="0.8" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function HuntressGlyph(props: GlyphProps) {
  // Drawn bow (curve on left) with a horizontal arrow ready to fire right.
  // Two converging strokes at the tip form a clean chevron arrowhead.
  return (
    <svg {...baseProps} {...props}>
      <path d="M 5 4 C 2 9, 2 15, 5 20" />
      <path d="M 6 12 L 19 12" />
      <path d="M 19 12 L 16 9 M 19 12 L 16 15" />
    </svg>
  );
}

export function QueenGlyph(props: GlyphProps) {
  return (
    <svg {...baseProps} {...props}>
      <path d="M5 9l3 3 4-5 4 5 3-3-1.5 6h-11Z" />
      <circle cx="12" cy="17.5" r="2.5" />
      <path d="M12 15v5" opacity="0.45" />
    </svg>
  );
}

export function EnchantressGlyph(props: GlyphProps) {
  // Masquerade mask — winged cat-eye outline with two solid eye dots.
  // Unmistakable as a mask even at small sizes.
  return (
    <svg {...baseProps} {...props}>
      <path d="M 3 10 C 4 8, 7 7, 10 9 C 11 10, 13 10, 14 9 C 17 7, 20 8, 21 10 C 21 14, 17 16, 14 14 C 13 13, 11 13, 10 14 C 7 16, 3 14, 3 10 Z" />
      <circle cx="8.2" cy="10.8" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="15.8" cy="10.8" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  );
}
